import type { TranslationTemplate } from "../../../application.i18n";

export default {
	title: "Dashboard",
	description: "Oversikt over systemets status.",
	lastUpdated: "Sist oppdatert: {{date}}",
	noDate: "Ingen dato",
	summaryCards: {
		feedAmount: "Fôrmengde",
		seaTemp: "Gjennomsnittlig sjøtemperatur",
		airTemp: "Gjennomsnittlig lufttemperatur",
		oxygen: "Oksygen",
		salinity: "Saltholdighet",
		wind: "Vind",
		readings: "Datamålinger",
	},
	detail: {
		population: {
			cullCount: "Cull",
			mortalityCount: "Dødelighet",
			populationCount: "Populasjon",
		},
		types: {
			oxygen: "Oksygen",
			depth: "Dybde",
			temperature: "Temperatur",
			salinity: "Saltholdighet",
		},
	},
	filter: {
		allSites: "Alle steder",
		allUnits: "Alle enheter",
		addSecondSite: "Legg til andre sted",
	},
	badges: {
		feeding: "Fôring",
		offline: "Offline",
		stopped: "Stoppet",
		noData: "Ingen data",
		active: "Aktiv",
		unknown: "Ukjent",
	},
	sortOptions: {
		name: "Navn",
		biomass: "Biomasse",
		activity: "Aktivitet",
		feeding: "Fôring",
	},
	filterOptions: {
		all: "Alle ({{value}})",
		active: "Aktiv ({{value}})",
		feeding: "Fôring ({{value}})",
		alarms: "Alarmer ({{value}})",
	},
	dataTypes: {
		error: {
			title: "Feil",
			description: "Klarte ikke laste inn data."
		}
	},
	population: {
		error: {
			title: "Feil",
			description: "Klarte ikke laste inn populasjons -data."
		}
	},
	feed: {
		intensity: "Intensitet",
		feedAmount: "Fôrmengde",
		recommendedFeedAmount: "Anbefalt fôrmengde",
		noData: "Ingen fôringsdata tilgjengelig",
		overflow: "Overfôring",
		error: {
			title: "Feil",
			description: "Klarte ikke laste inn fôrmengde."
		}
	},
	buttons: {
		search: "Søk",
		units: "Enheter",
		sites: "Steder",
		hideGraphics: "Skjul grafikker",
		showGraphics: "Vis grafikker",
		preferences: "Innstillinger",
		back: "Tilbake til {{value}}",
		backToMultipleSites: "Tilbake til steder",
		sortBy: "Sorter etter:",
		addNewView: "Legg til ny visning",
		closeView: "Lukk visning",
	},
	loading: {
		liveView: {
			sites: "Laster steder...",
			units: "Laster enheter...",
		},
	},
	errors: {
		liveView: {
			sites: {
				title: "Feil ved lasting av lokasjoner {{value}}",
				description: "Noe gikk galt ved lasting av lokasjoner. Prøv igjen senere eller med et annet selskap.",
			},
			units: {
				title: "Feil ved lasting av enheter {{value}}",
				description: "Noe gikk galt ved lasting av enhetene. Prøv igjen senere eller med et annet sted.",
			}
		}
	}
} satisfies TranslationTemplate["HOME"];
